<template>
    <!-- Room Code (this will be placed next to Name in the name-block slot) -->
    <v-col cols="12" md="4">
        <v-text-field
            v-model="modelValue.roomCode"
            :label="$t('room_code')"
            variant="outlined"
            color="primary"
            density="compact"
            data-cy="meal-code"
            :readonly="isFieldReadonly"
            :disabled="isFieldDisabled"
        />
    </v-col>
</template>

<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'
    import {contractServiceType, RoomCode} from '~/utils/types/types'
    import {useFlagIconCode} from '~/composables/helpers'

    const NewHtmlEditor = defineAsyncComponent(() => import('~/components/admin/NewHtmlEditor.vue'))

    const props = defineProps<{
        modelValue: any
        serviceType?: string
        categories: any[]
        isFieldReadonly: boolean
        isFieldDisabled: boolean
        baseFormRef: any
        isHotelDescriptionMode: boolean
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: any]
        'update-capacity': []
    }>()

    const {t} = useI18n()

    const useRoomCode = computed(() => {
        const roomCodes = ['OTHER', 'SINGLE', 'DOUBLE', 'TRIPLE', 'QUADRUPLE', 'FAMILY']
        return roomCodes.map(value => ({value: RoomCode[value], title: t(`roomCode.${value}`)}))
    })
</script>
